module.exports = __webpack_public_path__ + "img/progress_023.04827f37.png";